import React, { useState } from "react";

const DeleteCarByRecordNumber = () => {
  const [recordNumber, setRecordNumber] = useState("");
  const [car, setCar] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleFetchCar = async () => {
    try {
      const res = await fetch(`https://automotive-backend-production.up.railway.app/inventory/record/${recordNumber}`);
      if (!res.ok) {
        alert("Car not found!");
        return;
      }
      const data = await res.json();
      setCar(data);
      setShowModal(true);
    } catch (error) {
      alert("Error fetching car: " + error.message);
    }
  };

  const handleDelete = async () => {
    try {
      const res = await fetch(`https://automotive-backend-production.up.railway.app/inventory/record/${recordNumber}`, {
        method: "DELETE",
      });

      const result = await res.json();
      if (res.ok) {
        alert("Car deleted successfully.");
        setShowModal(false);
        setCar(null);
        setRecordNumber("");
      } else {
        alert(result.message);
      }
    } catch (error) {
      alert("Error deleting car: " + error.message);
    }
  };

  return (
    <div className="container mt-4">
      <h3>Delete Car by Record Number</h3>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Enter Record Number"
          value={recordNumber}
          onChange={(e) => setRecordNumber(e.target.value)}
        />
        <button className="btn btn-danger" onClick={handleFetchCar}>
          Find & Delete
        </button>
      </div>

      {/* Modal */}
      {showModal && car && (
        <div className="modal show fade d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this car?</p>
                <ul>
                  <li><strong>Name:</strong> {car.Name}</li>
                  <li><strong>Make:</strong> {car.Make}</li>
                  <li><strong>Model:</strong> {car.Model}</li>
                  <li><strong>Year:</strong> {car.Year}</li>
                  <li><strong>Color:</strong> {car.Color}</li>
                  <li><strong>Category:</strong> {car.Category}</li>
                </ul>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={handleDelete}>
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Backdrop */}
      {showModal && <div className="modal-backdrop fade show"></div>}
    </div>
  );
};

export default DeleteCarByRecordNumber;
